import { createContext } from 'react'
import {
  defaultLeadCardPreviewContext,
  LeadCardPreviewContext,
} from './LeadCardPreviewContext.types'

export const leadCardPreviewContext = createContext<LeadCardPreviewContext>(
  defaultLeadCardPreviewContext
)
